
import { filtersDTO, NotStructureResponseDTO } from "./dto";
import { NotStructureImpl } from "./serviceImpl";

export interface NotStructureService {
    GetAllStructure(filters: filtersDTO): Promise<NotStructureResponseDTO>
}

export function NewStructureService(): NotStructureService {
    return new NotStructureImpl()
}